// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import JQuery from "jquery";
window.$ = JQuery;

import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";

// loads the Icon plugin
UIkit.use(Icons);
window.UIkit = UIkit;

import api from "@/mixins/api";
import Asset from "@/components/Asset";
import Entries from "@/components/Entries";
import Anchor from "@/components/Anchor";
import Heading from "@/components/Heading";

Vue.config.productionTip = false;

Vue.mixin(api);
Vue.component("asset", Asset);
Vue.component("entries", Entries);
Vue.component("anchor", Anchor);
Vue.component("heading", Heading);

if (window.parent) {
  document.open = () => {};
  document.write = () => {};
  document.close = () => {};
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js